import AuthorHeroPage from './AuthorHeroPage';

export default AuthorHeroPage;
